import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CussettingsComponent } from './cussettings.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [CussettingsComponent],
  exports: [
    CussettingsComponent
  ],
  providers: [
  ]
})
export class CussettingsModule { }
